<template>
  <div>
   <b-navbar toggleable="md" type="dark" variant="info" v-if="widthMax > 768">
     <b-container :class="{'justify-content-center':format === 'center'}">
        <b-navbar-brand to="/">
          <b-img  :src="require('@/assets/img/logoTicket2.png')" fluid alt="Responsive image"></b-img>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse v-if="format !== 'center'" id="nav-collapse" is-nav>
          <b-navbar-nav class="ml-auto">
             <b-nav-item v-if="user.userLevel == 0"  right  target="_bank" :href="url+'profile'" class="mt-2">
              <b-button variant="outline-primary">
                BROWSE MENTORS
              </b-button>
            </b-nav-item>
             <b-nav-item v-else right target="_bank" :href="url+'form/edit'" class="mt-2">
              <b-button variant="outline-primary">
                GreatGrowth
              </b-button>
            </b-nav-item>
            <b-nav-item v-if="user.profilePic != '' && user.profilePic != null"  right >
              <div class="profilePic mg-x-3">
              <b-img  :src="imgPath+user.profilePic" width="40" alt="placeholder"></b-img>
            </div>
            </b-nav-item>
            <b-nav-item v-else right >
              <div class="profilePic mg-x-3">
              <img src="@/assets/img/user.png">
            </div>
            </b-nav-item>
             <b-nav-item-dropdown v-if="user" class="d-flex align-items-center" right>
              <!-- Using 'button-content' slot -->
              <template slot="button-content" class="d-flex align-items-center"><em class="text-white">{{user.name}}</em></template>
              <b-dropdown-item><router-link to="/review-comment" class="text-dark">Wait for review</router-link></b-dropdown-item>
              <b-dropdown-item @click="signout()">Sign out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
          
        </b-collapse>
      </b-container>
  </b-navbar>
    <b-navbar v-else toggleable="md" type="dark" variant="info">
      <b-container :class="{'justify-content-center':format === 'center'}">
          <b-navbar-brand to="/">
            <b-img  :src="require('@/assets/img/logoTicket2.png')" fluid alt="Responsive image"></b-img>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-collapse v-if="format !== 'center'" id="nav-collapse" is-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item class="text-center" v-if="user.userLevel == 0"  right  target="_bank" href="http://uat.mentor.lffintech.co.th/profile">
                <b-button variant="outline-primary">
                  BROWSE MENTORS
                </b-button>
              </b-nav-item>
              <b-nav-item v-if="user.profilePic != '' && user.profilePic != null" style="text-align: -webkit-center;">
                <div class="profilePic mg-x-3">
                <b-img  :src="imgPath+user.profilePic" width="40" alt="placeholder"></b-img>
              </div>
              <b-nav-item-dropdown v-if="user" class=" align-items-center dpNav"  style="justify-content: center;" >
                <template slot="button-content" class="d-flex align-items-center"><em class="text-white">{{user.name}}</em></template>
                <b-dropdown-item><router-link to="/review-comment" class="text-dark">Wait for review</router-link></b-dropdown-item>
                <b-dropdown-item @click="signout()">Sign out</b-dropdown-item>
              </b-nav-item-dropdown>
              </b-nav-item>
              <b-nav-item v-else right >
                <div class="profilePic mg-x-3">
                <img src="@/assets/img/user.png">
              </div>
              </b-nav-item>
              
            </b-navbar-nav>
            
          </b-collapse>
        </b-container>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'HelloWorld',
  data () {
    return {
      imgPath:'',
      url:process.env.VUE_APP_URL_MENTOR,
      widthMax: window.innerWidth,
    }
  },
  methods:{
    signout(){
      setTimeout(() => {
        window.localStorage.clear();
      }, 100);
      this.$store.commit("clearlogin");
      window.localStorage.removeItem("vuex");
      this.$router.push("/signin");
    },
  },
  created(){
    if(this.user.typeSystem == 'mentor'){
      this.imgPath = process.env.VUE_APP_IMG_PROFILE_MENTOR
    }else if(this.user.typeSystem == 'inteGreat'){
      this.imgPath = process.env.VUE_APP_IMG_PROFILE_INTEGREAT
    }else if(this.user.typeSystem == 'ticket'){
      this.imgPath = process.env.VUE_APP_IMG_PROFILE_TICKET
    }
  },
  computed: {
       ...mapState(["user"]),
  },
  components:{
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$blue : rgb(13, 106, 202);
$orange : #FFA800;
$orange-top : rgb(254,147,13);
$orange-bottom:  rgb(254,175,28);
$purple-top: rgb(139,98,228);
$purple-bottom: rgb(122,122,236);

 .btn-outline-primary{
  position: relative;
  top: 2px;
 }
 .profilePic{
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.profilePic img{
  max-width:100%!important;
  width: 100%;
}

.white{
  margin-left:5px;
  position: relative;
  top: 5px;
  color: white;
  font-weight: 500;
}
.bg-info{
  background-color: rgb(13, 106, 202) !important;
}
.navbar-brand{
    font-size: 1.55rem;
    font-weight: 500;
}
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue